import React from "react";
import PrivacyText from "../assets/data/privacyText.json";
import { Box, Divider, Typography } from "@mui/material";
import Footer from "./Footer";

const Privacy = () => {
    return (
        <>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "flex-start",
              minHeight: "95vh",
              width: "100vw",
              marginBottom: "1rem",
            }}
          >
            <Box
              sx={{
                width: "80vw",
                maxWidth: "600px",
                marginTop: "6rem",
              }}
            >
              <Typography
                sx={{
                  fontSize: "1.2rem",
                  marginBottom: "-0.25rem",
                  fontWeight: "900",
                }}
              >
                Privacy Policy
              </Typography>
              <Divider
                sx={{
                  borderColor: "#979797",
                  borderWidth: "0.05rem",
                  marginY: "1rem",
                }}
              />
              {PrivacyText.paragraphs.map((paragraph, index) => (
                <Typography
                  sx={{
                    fontSize: "0.875rem",
                    lineHeight: "1.5",
                    marginBottom: "1rem",
                  }}
                  key={index}
                >
                  {paragraph.text}
                </Typography>
              ))}
            </Box>
          </Box>
          <Footer />
        </>
      );
}

export default Privacy